/* tslint:disable */
/* eslint-disable */
import {
  NgModule,
  ModuleWithProviders,
  SkipSelf,
  Optional,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ActuatorService } from './services/actuator.service';
import { AirCraftService } from './services/air-craft.service';
import { PassengerTypeService } from './services/passenger-type.service';
import { IdTypeService } from './services/id-type.service';
import { NationalityService } from './services/nationality.service';
import { AirportService } from './services/airport.service';
import { PassengerService } from './services/passenger.service';
import { PassportService } from './services/passport.service';
import { TripService } from './services/trip.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ActuatorService,
    AirCraftService,
    PassengerTypeService,
    IdTypeService,
    NationalityService,
    AirportService,
    PassengerService,
    PassportService,
    TripService,
    ApiConfiguration,
  ],
})
export class ApiModule {
  static forRoot(
    params: ApiConfigurationParams
  ): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error(
        'ApiModule is already loaded. Import in your base AppModule only.'
      );
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
